import { ACTION_POPUP_VIEW_STATE_ENUM } from 'components/CategoriesActionPopup/constants';
import { COLLECTIONS_VIEW_STATE_TYPES } from 'components/CollectionsPopup/types';

enum POPUP_TYPES_ENUM {
  AUTH,
  ACTION,
  COLLECTIONS,
  DRIVE,
  TEMPLATE,
}

export enum TierPlans {
  PRO = 'pro',
  PLUS = 'plus',
  GOLD = 'gold_old',
  FREE = 'free',
}

type VIEW_STATE_TYPES = ACTION_POPUP_VIEW_STATE_ENUM | COLLECTIONS_VIEW_STATE_TYPES;

export type { VIEW_STATE_TYPES };
export default POPUP_TYPES_ENUM;

export const ITEMS_PER_PAGE = 40;

export const CHECKOUT_GTM_SOURCE = 'profile';
